import { useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'
import { ArticleItem } from 'types/data'
import AsideList from '../../../components/AsideList'
import { LatestArticles } from '../../../components/LatestArticles'
import { OtherCategories } from '../OtherCategories'

export const Details = ({
  categorySlug,
  latestArticles,
  totalLatestArticles,
}: {
  categorySlug?: string
  latestArticles: Array<ArticleItem>
  totalLatestArticles: number
}) => {
  const { t } = useTranslation('@mc/next')
  const { topArticles } = useStaticData<{
    topArticles: Array<ArticleItem>
  }>()

  return (
    <section className='container' data-testid='details'>
      <div className='row no-gutters'>
        <div className='col-lg-8 col-sm-12'>
          <div className='mc-pr-8'>
            <LatestArticles
              latestArticles={latestArticles}
              totalLatestArticles={totalLatestArticles}
              categorySlug={categorySlug}
            />
          </div>
        </div>
        <div className='col-4 d-none d-lg-block'>
          {topArticles.length && (
            <AsideList
              title={t('article.topArticle.title')}
              items={topArticles}
            />
          )}
          <OtherCategories />
        </div>
      </div>
    </section>
  )
}
